(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login-react/assets/react/pages/bankid/use-bankid-poll-status.js') >= 0) return;  svs.modules.push('/modules/player-login-react/assets/react/pages/bankid/use-bankid-poll-status.js');

'use strict';

const {
  logger
} = svs.playerLoginReact;
const {
  cancelCustomerLoginAsync,
  getBankIdAutoStartTokenAsync,
  pollCustomerLoginAsync
} = svs.playerLoginReact.bankid.BankidService;
const {
  bankidProgressStatus,
  bankIdErrorCodes,
  route
} = svs.playerLoginReact.constants;
const {
  useHistory
} = ReactRouterDOM;
const {
  storeCustomerType,
  saveRefForGUITest
} = svs.playerLoginReact.sharedComponents.sharedUtils;
const {
  handleShowBankIdErrorCode
} = svs.playerLoginReact.sharedComponents.Dialogs;
const {
  bankIdAutostartTokenChangenAction,
  setIsBankidOnThisDeviceDesktop
} = svs.playerLoginReact.store.playerloginreactactions;
const isBankId = true;
const {
  useCheckPlayerAfterSession
} = svs.playerLoginReact.sharedComponents;
const {
  useUrlHelper
} = svs.playerLoginReact.sharedComponents;

const useBankIdPollStatus = (isQrCode, isLogin, autoStartToken) => {
  logger.debug('*** init useBankIdPollStatus');
  logger.debug("*** autoStartToken: ".concat(autoStartToken));
  const dispatch = ReactRedux.useDispatch();
  const isReturnNewCustomer = ReactRedux.useSelector(state => state.playerloginreact.isReturnNewCustomer);
  const {
    returnUrl,
    isTestEnvironment
  } = ReactRedux.useSelector(state => state.playerloginreact);
  const {
    navigateToCancelUrl,
    getBankIdAppUrl
  } = useUrlHelper();
  const isBankidOnThisDeviceMobile = !isQrCode;
  const history = useHistory();
  const autoStartTokenRef = React.useRef('');
  const qrCodeRetries = React.useRef(9); 
  const isLastQrRetry = qrCodeRetries.current <= 1; 

  const [appUrl, setAppUrl] = React.useState('');
  const [qrCode, setQrCode] = React.useState('');
  const networkRetries = React.useRef(2);
  const isUnmountingRef = React.useRef(false);
  const timeOutRef = React.useRef(false);
  const [backendStatus, setBackendStatus] = React.useState(bankidProgressStatus.BEFORE_POLL);
  const [backendError, setBackendError] = React.useState(0);
  const checkPlayerAfterSessionAsync = useCheckPlayerAfterSession();
  const isBankidOnThisDeviceDesktop = ReactRedux.useSelector(state => state.playerloginreact.isBankidOnThisDeviceDesktop);
  const isStandardMobile = ReactRedux.useSelector(state => state.playerloginreact.isStandardMobile);

  const initBankIdcodeAsync = async () => {
    try {
      const response = await getBankIdAutoStartTokenAsync();
      const autoStartTokenLocal = response.autoStartToken;
      const qrDataLocal = response.qrData;
      if (!isUnmountingRef.current) {
        autoStartTokenRef.current = autoStartTokenLocal;
      }

      saveRefForGUITest(autoStartTokenLocal);
      if (isTestEnvironment) {
        dispatch(bankIdAutostartTokenChangenAction(autoStartTokenLocal));
      }
      logger.debug('**** Got autostarttoken: ', autoStartTokenLocal);
      const appUrlLocal = getBankIdAppUrl(autoStartTokenLocal);
      logger.debug('**** Got appUrl: ', appUrlLocal);
      !isUnmountingRef.current && setAppUrl(appUrlLocal);
      !isUnmountingRef.current && setQrCode(qrDataLocal);
    } catch (error) {
      logger.info('Error, could not get autostarttoken. Error was ', error);
      await handleShowBankIdErrorCode(history);
      navigateToCancelUrl();
    }
  };

  const checkBankIdLoginStatusAsync = async () => {
    logger.debug('**** In checkBankIdLoginStatusAsync: ', autoStartTokenRef.current);
    if (autoStartTokenRef.current) {
      try {
        const response = await pollCustomerLoginAsync(autoStartTokenRef.current);
        setQrCode(response.qrData);
        logger.debug('**** Got bankIdStatus: ', response);
        return response;
      } catch (error) {
        logger.info('Error, could not get checkBankIdLoginStatus. Error was ', error);
        return {
          progressStatus: -1,
          error
        };
      }
    } else {
      return {
        progressStatus: 0
      };
    }
  };

  const startTimeOutPoll = () => setTimeout(() => {
    const pollWithHandling = async () => {
      try {
        if (document.visibilityState === 'visible') {
          await pollContinuousBackend();
          logger.debug('### visible polling');
        } else {
          logger.debug('### hidden no polling');
          startTimeOutPoll();
        }
      } catch (error) {
        logger.info('Error, in checkBankIdLoginStatusChangeAsync-setTimeout. Error was ', error);
        await handleShowBankIdErrorCode(history);
        navigateToCancelUrl();
      }
    };
    pollWithHandling();
  }, 1000);

  const handleReturnWhenError = async errorCode => {
    if (!isBankidOnThisDeviceDesktop && isStandardMobile) {
      await handleShowBankIdErrorCode(history, errorCode, isBankidOnThisDeviceMobile);
      navigateToCancelUrl();
    } else {
      await handleShowBankIdErrorCode(history, errorCode, isBankidOnThisDeviceMobile);
      dispatch(setIsBankidOnThisDeviceDesktop(false));
    }
    const routeToPush = isLogin ? route.LOGIN_BANKID_START_ROUTE : route.REGISTRATE_BANKID_ROUTE;
    history.push(routeToPush);
  };
  const handleErrorTrackingAndReset = error => {
    var _svs;
    if (!((_svs = svs) !== null && _svs !== void 0 && (_svs = _svs.accountservices) !== null && _svs !== void 0 && (_svs = _svs.check_iam) !== null && _svs !== void 0 && _svs.isInSweden)) {
      var _svs2;
      logger.info("foreignLogin=\"true\" action=\"Login Failure\" label=\"bankid\" countryCode=\"".concat((_svs2 = svs) === null || _svs2 === void 0 || (_svs2 = _svs2.accountservices) === null || _svs2 === void 0 || (_svs2 = _svs2.check_iam) === null || _svs2 === void 0 ? void 0 : _svs2.countryCode, "\""));
    }
    svs.components.analytics.trackEvent({
      category: 'Users',
      action: 'Login Failure',
      opt_label: 'bankid',
      opt_value: error.code || 665
    });
    dispatch(bankIdAutostartTokenChangenAction(''));
  };
  const handlePollError = async error => {
    logger.debug('BankIdQrCode: checkStatusChange got progressStatus -1 error: ', error);
    if (error.code === bankIdErrorCodes.CUSTOMER_SCAN_TIMEOUT && isQrCode) {
      if (qrCodeRetries.current <= 0) {
        logger.debug("BankidQrCode: user took to long to scan QR-code");
        setQrCode('');
        setBackendError(bankIdErrorCodes.CUSTOMER_SCAN_TIMEOUT);
        handleErrorTrackingAndReset(error);
        return;
      }
      qrCodeRetries.current--;
      logger.debug("Generating new QR-code, retries left ".concat(qrCodeRetries.current));
      await initBankIdcodeAsync();
      timeOutRef.current = setTimeout(() => {
        const pollWithHandling = async () => {
          try {
            await pollContinuousBackend();
          } catch (pollError) {
            logger.info('Error, in checkBankIdLoginStatusChangeAsync-setTimeout. Error was ', pollError);
          }
        };
        pollWithHandling();
      }, 500);
    } else if (networkRetries.current > 0) {
      networkRetries.current = networkRetries.current - 1;
      timeOutRef.current = startTimeOutPoll();
      logger.info("Received network error: ".concat(error.code, ", retrying"));
    } else {
      logger.info('checkStatusChange got error: ', error);
      handleErrorTrackingAndReset(error);
      await handleReturnWhenError(error.code);
    }
  };
  const handleRetailCustomer = (response, progressStatus) => {
    var _svs3;
    logger.debug('checkStatusChange run: progressStatus === 20, 21 or 22');
    response.deviceId = undefined;
    response.requestId = undefined;
    response.requestInfo = undefined;
    response.eid = 'bankid';
    if (isReturnNewCustomer) {
      svs.components.Storage.browser.remove('returnUrl', 'player-login', () => {});
      response.returnUrl = returnUrl;
    }
    const newCustomerEvent = {
      category: 'Users',
      action: 'Customer Registration'
    };
    let customerType = '';
    switch (progressStatus) {
      case bankidProgressStatus.REACTIVATED_CUSTOMER:
        newCustomerEvent.opt_label = 'started_reactivated_customer_from_bankid';
        customerType = 'reactivated';
        break;
      case bankidProgressStatus.NEW_CUSTOMER:
        newCustomerEvent.opt_label = 'started_new_customer_from_bankid';
        customerType = 'new';
        break;
      case bankidProgressStatus.RETAIL_CUSTOMER:
        newCustomerEvent.opt_label = 'started_retail_customer_from_bankid';
        customerType = 'retail';
        break;
      default:
        logger.warn('Unexpected status in handleRetailCustomer:', progressStatus);
    }
    if (!((_svs3 = svs) !== null && _svs3 !== void 0 && (_svs3 = _svs3.accountservices) !== null && _svs3 !== void 0 && (_svs3 = _svs3.check_iam) !== null && _svs3 !== void 0 && _svs3.isInSweden)) {
      var _svs4;
      logger.info("foreignLogin=\"true\" action=\"".concat(newCustomerEvent.action, "\" label=\"").concat(newCustomerEvent.opt_label, "\" countryCode=\"").concat((_svs4 = svs) === null || _svs4 === void 0 || (_svs4 = _svs4.accountservices) === null || _svs4 === void 0 || (_svs4 = _svs4.check_iam) === null || _svs4 === void 0 ? void 0 : _svs4.countryCode, "\""));
    }
    svs.components.analytics.trackEvent(newCustomerEvent, () => {
      storeCustomerType(customerType, () => {
        svs.utils.form.postToUrl("".concat(svs.core.urlMapping.get('customerRegistrationCompletion')), response, 'POST');
      });
    });
  };

  const pollContinuousBackend = React.useCallback(async () => {
    if (isUnmountingRef.current) {
      logger.debug("*** pollContinuousBackend - isUnmountingRef: ".concat(isUnmountingRef.current));
    } else {
      logger.debug("*** pollContinuousBackend - autoStartToken: ".concat(autoStartTokenRef.current));
      const response = await checkBankIdLoginStatusAsync();
      logger.debug('*** pollContinuousBackend - response');
      logger.debug(response);
      const {
        progressStatus,
        session,
        error
      } = response;
      if (session) {
        setBackendStatus(bankidProgressStatus.ONLINE_CUSTOMER);
        await checkPlayerAfterSessionAsync(isBankId, response, isQrCode);
        return;
      }
      setBackendStatus(progressStatus);
      logger.debug(progressStatus);
      if (progressStatus < 6 && progressStatus > 0 && !session && !isUnmountingRef.current) {
        timeOutRef.current = startTimeOutPoll();
      } else {
        switch (progressStatus) {
          case bankidProgressStatus.ONLINE_CUSTOMER:
            checkPlayerAfterSessionAsync(isBankId, response, isQrCode);
            break;
          case bankidProgressStatus.NEW_CUSTOMER:
          case bankidProgressStatus.RETAIL_CUSTOMER:
          case bankidProgressStatus.REACTIVATED_CUSTOMER:
            handleRetailCustomer(response, progressStatus);
            break;
          case bankidProgressStatus.ERROR_POLL:
            handlePollError(error);
            break;
          default:
            logger.info('checkBankIdStatusChange invalid state', progressStatus);
        }
      }
    }
  }, [history, isLogin, isQrCode, isBankidOnThisDeviceMobile, useCheckPlayerAfterSession, document.visibilityState]);

  const cancelBackendPoll = async () => {
    logger.debug('*** function cancelBackendPoll...');
    timeOutRef.current && clearTimeout(timeOutRef.current);
    isUnmountingRef.current = true;
    if (autoStartTokenRef.current && autoStartTokenRef.current.length > 10) {
      dispatch(bankIdAutostartTokenChangenAction(''));
      await cancelCustomerLoginAsync(autoStartTokenRef.current);
      autoStartTokenRef.current = '';
    }
  };

  const getStartBankId = React.useCallback(async () => {
    logger.debug('*** init useBankIdPollStatus-async useEffect');
    try {
      if (!autoStartToken) {
        logger.debug('*** initBankIdcodeAsync');
        await initBankIdcodeAsync();
      } else {
        autoStartTokenRef.current = autoStartToken;
      }
      logger.debug('*** pollBackend');

      timeOutRef.current = setTimeout(() => {
        const pollWithHandling = async () => {
          try {
            await pollContinuousBackend();
          } catch (error) {
            logger.info('Error, in checkBankIdLoginStatusChangeAsync-setTimeout. Error was ', error);
            await handleShowBankIdErrorCode(history);
            navigateToCancelUrl();
          }
        };
        pollWithHandling();
      }, 500);
      logger.debug('*** after pollBackend');
    } catch (error) {
      logger.debug("useBankIdPollStatus error:".concat(error));
      await handleShowBankIdErrorCode(history);
      navigateToCancelUrl();
    }
  }, [pollContinuousBackend, autoStartToken]);

  React.useEffect(() => {
    logger.debug('*** init useBankIdPollStatus-useEffect');
    getStartBankId();
    return () => {
      logger.debug('*** end polling, unmounting...');
      isUnmountingRef.current = true;
      timeOutRef.current && clearTimeout(timeOutRef.current);
      if (!isStandardMobile) {
        logger.debug('*** end polling, calling cancelBackendPoll...');
        cancelBackendPoll();
      }
    };
  }, []);
  return {
    appUrl,
    qrCode,
    backendStatus,
    cancelBackendPoll,
    isLastQrRetry,
    backendError
  };
};
svs.playerLoginReact.bankid.useBankIdPollStatus = useBankIdPollStatus;

 })(window);